import React from 'react';

const TermsPage = () => {
  return (
    <div className="bg-white min-h-screen font-sans text-[#7a7a7a]">
      {/* Header Section */}
      <div className="relative h-48 bg-gray-200 flex flex-col items-center justify-center bg-cover bg-center" style={{ backgroundImage: 'url("https://via.placeholder.com/1500x400")' }}>
        <div className="absolute inset-0 bg-black/10 backdrop-blur-[2px]"></div>
        <div className="relative z-10 text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-black uppercase tracking-wider">Terms and Conditions</h1>
          <p className="text-sm mt-2 text-gray-600">Home <span className="mx-2">»</span> Terms and Conditions</p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-16 space-y-20">
        
        {/* 1. Headings Section */}
        <section>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-10">
            {[1, 2, 3, 4, 5, 6].map((num) => (
              <div key={num}>
                <h2 className={`font-bold text-black uppercase mb-3 ${num === 1 ? 'text-2xl' : num === 2 ? 'text-xl' : 'text-lg'}`}>
                  Heading H{num}
                </h2>
                <p className="text-[14px] leading-relaxed">
                  Axis Theme is a very slick and clean e-commerce template with endless possibilities. Creating an awesome website with this Theme is easy than you can imagine.
                </p>
              </div>
            ))}
          </div>
        </section>

        {/* 2. Blockquotes */}
        <section>
          <h3 className="text-black font-bold uppercase mb-8 border-b pb-2">Blockquotes</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-10 text-center italic border-l-4 border-gray-200">
              <p className="text-lg">"Be who you are and say what you feel, because those who mind don't matter, and those who matter don't mind"</p>
              <cite className="block mt-4 not-italic font-semibold text-sm">— Bernard M. Baruch</cite>
            </div>
            <div className="p-10 text-center italic">
              <p className="text-lg">"Be who you are and say what you feel, because those who mind don't matter, and those who matter don't mind"</p>
              <cite className="block mt-4 not-italic font-semibold text-sm">— Bernard M. Baruch</cite>
            </div>
          </div>
        </section>

        {/* 3. Dropcaps */}
        <section>
          <h3 className="text-black font-bold uppercase mb-8">Dropcaps</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-[14px] leading-relaxed">
            <p>
              <span className="float-left text-5xl font-serif mr-3 mt-1 text-orange-200">D</span>
              otThemes is a very slick and clean e-commerce template with endless possibilities. Creating an awesome clothes store with this Theme is easy than you can imagine. We possess within us two minds. So far I have written only of the conscious mind.
            </p>
            <p>
              <span className="float-left text-2xl font-bold bg-orange-100 text-orange-800 w-10 h-10 flex items-center justify-center mr-3 mt-1">D</span>
              otThemes is a very slick and clean e-commerce template with endless possibilities. Creating an awesome clothes store with this Theme is easy than you can imagine. We possess within us two minds. So far I have written only of the conscious mind.
            </p>
          </div>
        </section>

        {/* 4. Bullets & Lists */}
        <section>
          <h3 className="text-black font-bold uppercase mb-8 border-b pb-2">Bullets & Lists</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-[13px]">
            <ul className="space-y-2">
              {['Our Theme is a very slick', 'Clean & minimal design', 'The best theme ever', 'Super flexible template'].map(li => (
                <li key={li} className="flex items-center gap-2"><span className="text-gray-400">•</span> {li}</li>
              ))}
            </ul>
            <ul className="space-y-2">
              {['Our Theme is a very slick', 'Clean & minimal design', 'The best theme ever', 'Super flexible template'].map(li => (
                <li key={li} className="flex items-center gap-2"><span className="text-gray-400">−</span> {li}</li>
              ))}
            </ul>
            <ul className="space-y-2">
              {['Our Theme is a very slick', 'Clean & minimal design', 'The best theme ever', 'Super flexible template'].map(li => (
                <li key={li} className="flex items-center gap-2"><span className="text-gray-400">→</span> {li}</li>
              ))}
            </ul>
            <ul className="space-y-2 list-decimal list-inside">
              <li>Our Theme is a very slick</li>
              <li>Clean & minimal design</li>
              <li>The best theme ever</li>
              <li>Super flexible template</li>
            </ul>
          </div>
        </section>

        {/* 5. Columns Demo */}
        <section className="space-y-12">
          <h3 className="text-black font-bold uppercase border-b pb-2">Columns</h3>
          
          {/* 1/2 Column */}
          <div className="grid grid-cols-2 gap-8">
            <div className="space-y-2"><h4 className="font-bold text-black text-xs uppercase">1/2 Column</h4><p className="text-[12px]">Our Theme is a very slick and clean e-commerce template with endless possibilities.</p></div>
            <div className="space-y-2"><h4 className="font-bold text-black text-xs uppercase">1/2 Column</h4><p className="text-[12px]">Our Theme is a very slick and clean e-commerce template with endless possibilities.</p></div>
          </div>

          {/* 1/3 Column */}
          <div className="grid grid-cols-3 gap-8">
            {[1, 2, 3].map(i => (
              <div key={i} className="space-y-2"><h4 className="font-bold text-black text-xs uppercase">1/3 Column</h4><p className="text-[12px]">Axis Theme is a very slick and clean template.</p></div>
            ))}
          </div>

          {/* 1/4 Column */}
          <div className="grid grid-cols-4 gap-8">
            {[1, 2, 3, 4].map(i => (
              <div key={i} className="space-y-2"><h4 className="font-bold text-black text-xs uppercase">1/4 Column</h4><p className="text-[12px]">Axis Theme is a very slick.</p></div>
            ))}
          </div>
        </section>
      </div>

      {/* Footer Newsletter Area */}
      <div className="bg-gray-50 py-10 border-t border-gray-100">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
          <h4 className="font-bold text-black uppercase text-sm tracking-widest">Get the latest updates</h4>
          <div className="flex w-full md:w-auto">
            <input type="email" placeholder="Enter your email" className="px-4 py-2 border border-gray-200 w-full md:w-64 focus:outline-none text-sm" />
            <button className="bg-black text-white px-8 py-2 text-xs uppercase font-bold tracking-tighter">Subscribe</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;